import { Phrases } from '@shared/models/locales.model';

export default {
  AssignedTo: 'مسند إلى',
  AcceptedBy: 'تم القبول من',
  Driver: 'السائق',
  Truck: 'الشاحنة',
  Location: 'الموقع',
  GateDefinition: {
    inBound: 'الوارد',
    outBound: 'الصادر',
    both: 'كليهما',
    temperatureControl: 'التحكم في درجة الحرارة',
    temperatureControlText: 'إذا لم يتم اختياره، يعني أن درجة حرارة البوابة طبيعية.',
    gateName: 'إسم البوابة',
    referenceID: 'معرف المرجع',
    truckClassify: 'تصنيف الشاحنة',
    Frozen: 'مجمد',
    Chiller: 'مبرِّد',
    GatesManagement: 'إدارة البوابات',
    addGateDesc: 'اضغط على "إضافة بوابة" لإعداد بوابات الموقع',
    addGate: 'إضافة بوابة',
    addAnotherGate: 'إضافة بوابة أخرى',
    gates: 'البوابات',
    DeviceDistance: 'مسافة الجهاز',
  },
  ShippingCard: {
    Pickup: 'الاستلام',
    Dropoff: 'التسليم',
    Clients: 'عملاء',
    Orders: 'طلبات',
    ContactPerson: 'مسؤول التواصل',
    NoContact: 'لا يوجد مسؤول تواصل',
    Phone: 'الهاتف',
    NotMentioned: 'غير مذكور',
    PickupTime: 'وقت الاستلام',
    DropoffTime: 'وقت التسليم',
    CompletedOn: 'تم الإنجاز في',
    NotDeliveredYet: 'لم يتم التسليم بعد',
    NotCompletedYet: 'لم يكتمل بعد',
    OTP: 'رمز التحقق',
  },
  PlateNumber: {
    External: 'خارجية',
  },
  'ShipmentAssignment.OverrideDetected': 'تم الكشف عن تجاوز',
  'ShipmentAssignment.HasRunningShipment': '  لدية رحلة قائمة  ',
  'ShipmentAssignment.From': ' من  ',
  'ShipmentAssignment.Kindly': ' برجاء العلم ان  ',
  'ShipmentAssignment.TheDriver': ' هذا السائق ',
  'ShipmentAssignment.TheTruck': ' هذه الشاحنة ',
  'ShipmentAssignment.To': 'إلى',
  'ShipmentAssignment.CloseShipment': 'هل تريد اغلاق الشحنة',
  'ShipmentAssignment.ThisShipment': 'هذه الشحنة',
  'ShipmentAssignment.ThoseShipments': 'تلك الشحنات  ',
  'ShipmentAssignment.WillStart': 'ستبدأ عندما يتم تسليم ',
  'ShipmentAssignment.Shipment': 'الشحنة',
  'ShipmentAssignment.SuccessfullyDelivered': 'بنجاح',
  'ShipmentAssignment.ScheduleConflict': 'تعارض في الجدولة',
  'ShipmentAssignment.ConfirmOverride': 'تأكيد التجاوز',
  'ShipmentAssignment.ConfirmOverrideHint': 'إغلاق الرحلة القائمة ثم تعيين هذه الشحنة.',
  'ShipmentAssignment.JustAssign': 'تعيين فقط',
  'ShipmentAssignment.JustAssignHint': 'تعيين هذه الشحنة مع إبقاء الرحلة القائمة كما هي.',
  'ShipmentAssignment.AssignAndAutoStart': 'تعيين وبداية',
  'ShipmentAssignment.AssignAndAutoStartHint': 'التعيين الآن وبدء الشحنة تلقائياً بعد تسليم الرحلة القائمة.',
  'ShipmentAssignment.Justification': 'الأسباب',
  'ShipmentAssignment.ErrorMessageRequired': 'حقل مطلوب',
  'ShipmentAssignment.Hint': 'تلميح',
  'Orders.AllOrdersWithCount': 'جميع {{count}} الطلبات',
  'Orders.PalletsWithCount': 'البالات {{count}}',
  'Orders.ItemsWithCount': 'العناصر {{count}}',
  'Orders.CreatedAt': 'تم الإنشاء في',
  'Orders.Pallets': 'البالات',
  'Orders.Items': 'العناصر',
  'OrderType.StockToCustomerStock': 'نقل مخزون',
  'OrderType.StoTransfer': 'نقل مخزون',
  'OrderType.Z122': 'نقل مخزون',
  'OrderType.MOIR': 'MOI-R',
  'OrderType.ZPG1': 'ZPG1',
  'OrderType.CustomerOutboundOrders': 'نقل صادر',
  'OrderType.CustomerReturn': 'إرجاع العميل',
  'OrderType.CustomerReturnNupcoStock': 'إرجاع العميل لمخزون نوبكو',
  'OrderType.NupcoSalesReturns': 'إرجاع مبيعات نوبكو',
  'OrderType.DistributionOutboundOrder': 'أمر صادر للتوزيع',
  'OrderType.TransferOrders': 'أوامر النقل',
  'OrderType.VendorSupplierReturns': 'إرجاع الموردين',
  'OrderType.SalesOrder': 'طلب مبيعات',
  'OrderType.NupcoRoyalCourt': 'نوبكو المحكمة الملكية',
  'OrderType.NupcoDonationIssue': 'نوبكو تبرعات',
  'OrderType.ScrapOrders': 'أوامر الخردة',
  'OrderType.PrepareOrder': 'تحضير الطلب',
  'OrderType.SalesWithPrice': 'مبيعات بالسعر',
  FailedToLogout: 'فشل تسجيل الخروج',
  LoggedOutSuccessfully: 'تم تسجيل الخروج بنجاح',
  FleetSurveyTitle: ' ! 🎉 عمل رائع، لقد أكملت 20 شحنة جديدة',
  ThankYouMessage: 'شكرًا لاستخدامك  منصة سوق النقل',
  RatingMessage: 'يرجى أخذ لحظة لتقييم تجربتك، مدخلاتك تساعدنا في خدمتكم بشكل أفضل.',
  Excellent: 'ممتاز',
  Good: 'جيد',
  Bad: 'سيء',
  Submit: 'إرسال',
  Notes: 'ملاحظات',
  CompleteInfoText: 'استكمل بياناتك للحصول على شحنات موثوقة مع شركاء معتمدين، وفواتير رسمية، وتتبع لحظي',
  CompleteInfo: 'استكمال البيانات',
  CompleteInfoTitle: 'استكمل بياناتي',
  CompleteInformationText: 'استكمل بياناتك للحصول على شحنات موثوقة مع شركاء معتمدين، وفواتير رسمية، وتتبع لحظي',
  CRNumber: 'رقم السجل التجاري',
  VATNumber: 'الرقم الضريبي',
  CompanyName: 'اسم الشركة',
  CompanyNamePlaceholder: 'أدخل اسم شركتك',
  CRNumberPlaceholder: 'أدخل رقم السجل التجاري',
  VATNumberPlaceholder: 'أدخل الرقم الضريبي',

  Title: 'المجمّع',
  MovedTitle: 'تم نقل لوحة تحكم B2C',
  Description:
    'لوحة إدارة B2C أصبحت متاحة الآن على منصة منفصلة. يرجى استخدام الرابط أدناه للوصول إليها.',
  LoginInfo: 'يمكنك تسجيل الدخول باستخدام نفس البريد الإلكتروني أو رقم الهاتف وكلمة المرور.',
  NewLocation: 'الموقع الجديد',
  Url: 'lastmile.madar.app',
  BookmarkNote:
    'للاستمرار في الاستمتاع بوصول غير منقطع، يرجى تحديث الإشارات المرجعية والروابط المحفوظة.',
  GoButton: 'الانتقال إلى B2C Admin',
  OpenNewTab: 'فتح في تبويب جديد',
  Footer: 'تم إجراء هذا التغيير لتحسين الأداء وتجربة المستخدم',
  RenewPasswordReminder: 'تذكير بتجديد كلمة المرور',
  NoticeTitle: 'تنبيه: ستنتهي صلاحية كلمة مرورك قريبًا',
  NoticeBody:
    'ستنتهي صلاحية كلمة مرورك خلال {{days}} أيام. يمكنك التجديد في أي وقت من إعدادات حسابك.',
  ReminderTitle: 'تذكير: ستنتهي صلاحية كلمة مرورك قريبًا',
  ReminderBody: 'ستنتهي صلاحية كلمة مرورك خلال {{days}} أيام. نوصي بالتجديد مبكرًا لتجنب الانقطاع.',
  UrgentTitle: 'عاجل: ستنتهي صلاحية كلمة مرورك قريبًا!',
  UrgentBodyDays:
    'لم يتبق سوى {{days}} يوم/أيام قبل انتهاء صلاحية كلمة مرورك. جدد فورًا لتجنب الانقطاع.',
  UrgentBodyExpired: 'انتهت صلاحية كلمة مرورك. جدد الآن لاستعادة الوصول إلى جميع الخدمات.',
  DaysRemainingLabel: 'متبقي {{days}} يوم/أيام',
  PasswordExpiredLabel: 'انتهت صلاحية كلمة المرور',
  Expired: 'منتهي',
  DaysLeft: 'أيام متبقية',
  RemindMeLater: 'ذكرني لاحقًا',
  RenewNow: 'جدد كلمة المرور الآن',
  MarkedAutoDelivered: 'تم وضع حالة تم التسليم تلقائيًا',
  BySystem: 'من النظام',
} as Phrases;
